import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import PackageCard from './PackageCard';
import RealEstateBannerMobile from './realEstateBannerMobile';

/**
 * PackageSelection.
 * Component for handling product package selection.
 *
 * @author  Manny
 * @param   {String}      props.method           Optional industry params.
 * @param   {Function}    props.onSelectPackage  Handles onClick for selecting a package.
 * @param   {Object}      props.productPackages  List of packages for the product.
 * @param   {String}      props.selectedIndustry Name of selected industry.
 * @param   {String}      props.selectedPackage  Name of selected package.
 * @returns {JSX.Element} The component markup.
 */

const secondFootNoteBullets = [
  'AFG',
  'Agent Box',
  'Agent Point / Proposal Point',
  'Box + Dice',
  'CampaignTrack / Real Hub',
  'Click to Cloud',
  'Eagle Software',
  'E-Sales (Century21)',
  'Harcourts eCampaign',
  'LJH AVNU',
  'MyDesktop - Elders',
  'MyDesktop - Raine&Horne',
  'Realtair',
  'REAPIT',
  'RE-NET',
  'REX',
  'SalesTrekker',
  'Vault RE',
  'Zenu'
];

function* sliceBulletsArray(arr, n) {
  for (let i = 0; i < arr.length; i += n) {
    yield arr.slice(i, i + n);
  }
}

const PackageSelection = ({
  method,
  onSelectPackage,
  productPackages,
  selectedIndustry,
  selectedPackage
}) => {
  const [packageKey, setPackageKey] = useState(selectedPackage);
  const [currentProductPackages, setCurrentProductPackages] = useState(productPackages);

  const isMobile = /Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent);

  let classNames = require('classnames');

  const packageContainer = classNames({
    'row no-margin page-dim-package-selection packagesContainerCenter footnote-text': isMobile === false,
    'row no-margin page-dim-package-selection packagesContainerCenterMobile': isMobile === true
  });
  const noteClass = classNames({
    'note-text note-text-align margin-bottom-100 page-dim footnote-text': isMobile === false,
    'note-text margin-bottom-100 padding-right-10 page-dim padding-left-15': isMobile === true
  });

  useEffect(() => {
    if (isMobile) {
      let newPackageKey = packageKey;
      if (packageKey === 'basic1UN') {
        newPackageKey = 'basic';
      }

      setPackageKey(newPackageKey);
    }
    getFilteredDisplayFeatures();
  }, []);

  useEffect(() => {
    setPackageKey(selectedPackage);
  }, [selectedPackage]);

  const getFilteredDisplayFeatures = () => {
    let newProductPackages = currentProductPackages;
    let packageKeys = Object.keys(productPackages);
    for (let index = 0; index < packageKeys.length; index++) {
      let currentPackage = currentProductPackages[packageKeys[index]];

      if (index <= 1) {
        currentPackage.features.filteredFeatures = currentPackage.features.display;
        currentPackage.featuresText = 'Subscription Features Include:';
      }

      if (index > 1) {
        let previousPackage = currentProductPackages[packageKeys[index - 1]];
        if (
          previousPackage.features &&
          previousPackage.features.display &&
          currentPackage.features &&
          currentPackage.features.display
        ) {
          let currentDisplay = currentPackage.features.display;
          let previousDisplay = previousPackage.features.display;
          currentPackage.features.filteredFeatures = currentDisplay.filter(function (obj) {
            return !previousDisplay.some(function (obj2) {
              return obj.title === obj2.title;
            });
          });
          if (index == 3) {
            currentPackage.featuresText = `Subscription Features Include \n Everything in ${previousPackage.title} plus:`;
          } else if (index == 4) {
            const firstPackage = currentProductPackages[packageKeys[index - 2]];
            currentPackage.featuresText = `Subscription Features Include \n Everything in ${firstPackage.title} & ${previousPackage.title} plus:`;
          } else if (index == 5) {
            const firstPackage = currentProductPackages[packageKeys[index - 2]];
            const secondPackage = currentProductPackages[packageKeys[index - 3]];
            currentPackage.featuresText = `Subscription Features Include \n Everything in ${secondPackage.title}, ${firstPackage.title} and ${previousPackage.title} plus:`;
          }
        }
      }
      newProductPackages[packageKeys[index]] = currentPackage;
    }
    setCurrentProductPackages(newProductPackages);
  };

  const secondFootNoteBulletsTableData = [...sliceBulletsArray(secondFootNoteBullets, isMobile ? 2 : 5)].map(
    (bullets, index) => {
      return (
        <tr key={`second-foot-note-bullet-${index}`}>
          <td>&nbsp;&nbsp;</td>
          {bullets.map((bullet) => {
            return (
              <td key={bullet}>
                <li>{bullet}</li>
              </td>
            );
          })}
        </tr>
      );
    }
  );


  return (
    <div>
      <div className='packagesContainer'>
        {true && (
          <div className={packageContainer}>
            {Object.keys(currentProductPackages).map((newPackageKey, packageIndex) => {
              let singlePackage = currentProductPackages[newPackageKey];
              let oneMonth = currentProductPackages['one_month'];
              if (
                singlePackage.key !== 'trial' &&
                singlePackage.key !== 'one_month' &&
                singlePackage.enabled &&
                singlePackage?.visible !== false
              ) {
                return (
                  <React.Fragment key={`package_card_${packageIndex}`}>
                    <PackageCard
                      singlePackage={singlePackage}
                      packageIndex={packageIndex}
                      selectedIndustry={selectedIndustry}
                      onSelectPackage={onSelectPackage}
                      method={method}
                      isMobile={isMobile}
                      oneMonth={oneMonth}
                    />
                  </React.Fragment>
                );
              }
              return '';
            })}
          </div>
        )}
        {false && (
          <div className='row margin-bottom-100'>
            <RealEstateBannerMobile
              onSelectPackage={onSelectPackage}
              productPackages={currentProductPackages}
              packageKey={packageKey}
              selectedIndustry={selectedIndustry}
              isMobile={isMobile}
            />
          </div>
        )}
      </div>
      <div id="package-card-footnotes" className={noteClass}>
        <div className='package-selection-footnote-table-block'>
          <p>
            <sup>1</sup> Eligible CRMs or PropTech Solutions currently include:
          </p>
          <table className='table footnotes-table package-selection-footnotes-table'>
            <tbody>{secondFootNoteBulletsTableData}</tbody>
          </table>
        </div>
        <p>
          <sup>2</sup> Capped at 10,000 properties/month
        </p>
        <p><b>Terms & Conditions</b></p>
        <p>
          Lite Package available for 1,3 and 5 users. Base Premium and Pro packages available
          for 1, 3, 5, 10, 15 and 25 users.
        </p>
        <p>
          Note: Some features are currently available in RP Data Professional only, and will be
          transitioned to RP Data in due course. CoreLogic intends that users will continue to have
          access to these features (if included in the user’s chosen package) during and after this transition.
        </p>
        <p>
          Note: Agency Benchmark Reports (ABR). Available in subscriptions for Agencies only.
          Please note that the sales, listings and agent information used to calculate the analytics
          in the ABR report may not be recorded or available for all residential properties at the
          time of publication, and supply of ABR is subject to the Cotality Disclaimers.
          Cotality cannot guarantee that the Customer's specific agency information will appear in the ABR.
        </p>
      </div>
    </div>
  );
};

PackageSelection.propTypes = {
  method: PropTypes.string,
  onSelectPackage: PropTypes.func.isRequired,
  productPackages: PropTypes.object.isRequired,
  selectedIndustry: PropTypes.string.isRequired,
  selectedPackage: PropTypes.string.isRequired
};

export default PackageSelection;
